/**
 * Returns the airport code from the parentheses in the airport name
 * @param fullName The full name of the airport e.q 'Amsterdam Airport Schiphol (AMS)'
 */
export function getAirportCodeFromParentheses(fullName: string): string {
  return fullName.split(' ')[1].replace('(', '').replace(')', '');
}
